import { render, staticRenderFns } from "./subInsuranceSetting.vue?vue&type=template&id=13cb7fd3&scoped=true&"
import script from "./subInsuranceSetting.vue?vue&type=script&lang=js&"
export * from "./subInsuranceSetting.vue?vue&type=script&lang=js&"
import style0 from "./subInsuranceSetting.vue?vue&type=style&index=0&id=13cb7fd3&scoped=true&lang=scss&ref=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cb7fd3",
  null
  
)

export default component.exports